import { useEffect, useState } from "react";
import { AlertCircle } from "lucide-react";

/**
 * Sticky CTA discreto: porta alla sezione "Invia segnalazione".
 * Volutamente sobrio per non disturbare la lettura.
 */
export const StickyWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 800);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="/segnalazioni"
      data-testid="sticky-report-btn"
      aria-label="Invia una segnalazione"
      className={`fixed z-40 bottom-5 right-5 sm:bottom-7 sm:right-7 inline-flex items-center gap-2 rounded-lg bg-[#2E4F3B] text-white font-semibold px-4 py-3 sm:px-5 sm:py-3.5 hover:bg-[#1f3828] transition-all duration-300 shadow-lg ${
        visible
          ? "translate-y-0 opacity-100"
          : "translate-y-24 opacity-0 pointer-events-none"
      }`}
    >
      <AlertCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">Segnala</span>
    </a>
  );
};
